module.exports = __webpack_public_path__ + "static/default-post-image-dd9805a2c5ae79d6e0d37cabb592517b.jpg";